<template>
  <span
    :data-label="!disabled ? label : ''"
    :class="[newColor, newPosition, size, {
      'd-tooltip': active,
      'is-square': square,
      'is-animated': newAnimated,
      'is-always': always,
      'is-multiline': multilined,
      'is-dashed': dashed
    }]"
  >
    <slot />
  </span>
</template>

<script>
  import { defineComponent } from 'vue';

  /**
   * @displayName Tooltip
   */
  export default defineComponent({
    name: 'DTooltip',
    props: {
      /**
       * Tooltip text
       */
      label: String,

      /**
       * Set as `true` to keep tooltip open, or to open programmatically.
       */
      active: {
        type: Boolean,
        default: true,
      },

      /**
       * Any color is available as long as it is declared at the configuration and tailwind level.
       */
      color: {
        type: String,
        default: 'primary-500',
      },

      /**
       * Position of the tooltip.
       * @parameters top, bottom, left, right
       */
      position: {
        type: String,
        default: 'top',
        validator(value) {
          return [
            'top',
            'bottom',
            'left',
            'right',
          ].indexOf(value) > -1;
        },
      },

      /**
       * Tooltip will be always active
       */
      always: {
        type: Boolean,
        default: false,
      },

      /**
       * Tooltip will have a little fade animation
       */
      animated: {
        type: Boolean,
        default: true,
      },

      /**
       * Tooltip will be square (not rounded corners)
       */
      square: {
        type: Boolean,
        default: false,
      },

      /**
       * Tooltip slot will have a dashed underline
       */
      dashed: {
        type: Boolean,
        default: false,
      },

      /**
       * Tooltip will be multilined
       */
      multilined: {
        type: Boolean,
        default: false,
      },

      /**
       * Tooltip multiline size. Controls the width of the multiline. (only works for multilined tooltips)
       * @parameters small, medium, large
       */
      size: {
        type: String,
        default: 'medium',
        validator: (value) => ['small', 'medium', 'large'].indexOf(value) > -1,
      },

      disabled: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      newColor() {
        return `d-tooltip-${this.color}`;
      },

      newAnimated() {
        return this.animated;
      },

      newPosition() {
        return `is-${this.position}`;
      },
    },
  });
</script>